module.exports = __webpack_public_path__ + "static/logo-notext-nobg-41851354d570bfcce0f49bf3b0e84e2a.png";